/*
|-------------------------------------------------------------------------------
| VUEX modules/playlists.js
|-------------------------------------------------------------------------------
| The Vuex data store for the playlists
*/

import Vue from 'vue';

import PlaylistAPI from '../api/playlist.js';

var helper = require('../vuex-reusable-functions.js');

export const playlists = {
	/* Defines the state being monitored for the module. */
	state: {
		playlists: [],
		playlistsLoadStatus: 0,

		playlist: {
			title: '',
			description: '',
			userUUID: '',
			projects: [],
			password: '',
			hash_id: ''
		},
		playlistLoadStatus: 0,

		playlistEdit: {},
		playlistEditLoadStatus: 0,
		playlistEditStatus: 0,
		playlistEditText: '',

		playlistAddStatus: 0,

		playlistDeleteStatus: 0
	},

	/* Defines the actions used to retrieve the data. */
	actions: {
		/* Loads the playlists from the API */
		loadPlaylists({ commit }) {
			commit('setPlaylistsLoadStatus', 1);

			PlaylistAPI.getPlaylists()
				.then(response => {
					commit('setPlaylists', response.data);
					commit('setPlaylistsLoadStatus', 2);
				})
				.catch(() => {
					commit('setPlaylists', []);
					commit('setPlaylistsLoadStatus', 3);
				});
		},

		/* Loads an individual playlist from the API */
		loadPlaylist({ commit }, data) {
			commit('setPlaylistLoadStatus', 1);

			return PlaylistAPI.getPlaylist(data.id)
				.then(response => {
					commit('setPlaylist', response.data);
					commit('setPlaylistLoadStatus', 2);
				})
				.catch(() => {
					commit('setPlaylist', {});
					commit('setPlaylistLoadStatus', 3);
				});
		},

		/* Deletes an individual playlist from the API */
		deletePlaylist({ commit, state, dispatch }, id) {
			commit('setPlaylistDeleteStatus', 1);

			PlaylistAPI.deletePlaylist(id)
				.then(response => {
					commit('setPlaylist', {});
					commit('setPlaylistDeleteStatus', 2);
					dispatch('loadUserStatus');
				})
				.catch(() => {
					commit('setPlaylistDeleteStatus', 3);
				});
		},

		/* Loads a playlist to edit from the API */
		loadPlaylistEdit({ commit }, data) {
			commit('setPlaylistEditLoadStatus', 1);

			PlaylistAPI.getPlaylistEdit(data.slug)
				.then(response => {
					commit('setPlaylist', response.data);
					// commit('setPlaylistEdit', response.data);
					commit('setPlaylistEditLoadStatus', 2);
				})
				.catch(() => {
					commit('setPlaylist', {});
					// commit('setPlaylistEdit', {});
					commit('setPlaylistEditLoadStatus', 3);
				});
		},

		/* Edits a playlist */
		editPlaylist({ commit, state, dispatch }, data) {
			console.log('editPlaylist: ', data);
			commit('setPlaylistEditStatus', 1);
			// commit('setPlaylist', data);
			data.projectsIDs = data.projects.map(opt => opt.id);
			// console.log('Project IDs: ', data.projectsIDs);
			return PlaylistAPI.putEditPlaylist(data)
				.then(response => {
					console.log('PlaylistAPI.putEditPlaylist: ', response);
					commit('setPlaylistEditText', response.data.title + ' has been successfully updated!');
					commit('setPlaylistEditStatus', 2);
					commit('setPlaylist', response);
					// dispatch('loadUserStatus');

					Vue.SuccessSwal('The playlist was updated.');

					// Commit the mutation with the new playlist data
					commit('updatePlaylistInState', response.data);

					return response;
				})
				.catch(error => {
					commit('setPlaylist', {});
					commit('setPlaylistEditStatus', 3);
					Vue.ErrorSwal(error);
					return error.response;
				});
		},

		/* Adds a new playlist */
		addPlaylist({ commit, state, dispatch }, data) {
			commit('setPlaylistAddStatus', 1);

			return PlaylistAPI.postAddNewPlaylist(
				data.title,
				data.description,
				data.userUUID,
				data.projectID,
				data.password
			)
				.then(response => {
					console.log('addPlaylist succeeded!', response.status);
					console.log('addPlaylist succeeded!', response.data);
					commit('setPlaylist', response.data);
					commit('setPlaylistAddStatus', 2);
					dispatch('loadUserStatus');
					return response;
				})
				.catch(e => {
					console.log('addPlaylist failed! ', e.response);
					commit('setPlaylist', {});
					commit('setPlaylistAddStatus', 3);
					return e.response;
				});
		},

		clearSingle({ commit, state, dispatch }) {
			commit('clearSingle');
			commit('setPlaylistLoadStatus', 0);
		},

		removeVirtualProjectFromPlaylist({ commit, state, dispatch }, hashID) {
			// var objIndex = state.all.findIndex(obj => obj.hash_id == hash_id);
			// console.log('Project found at index: ' + objIndex);
			state.playlist.projects.splice(
				state.playlist.projects.findIndex(el => el.hash_id === hashID),
				1
			);
		}
	},

	/* Defines the mutations used */
	mutations: {
		setProp: helper.set('playlist'),

		updatePlaylistInState(state, updatedPlaylist) {
			const index = state.playlists.findIndex(playlist => playlist.id === updatedPlaylist.id);

			if (index !== -1) {
				// Replace the old playlist data with the new data
				Vue.set(state.playlists, index, updatedPlaylist);
			}
		},

		/* Sets the playlists */
		setPlaylists(state, playlists) {
			state.playlists = playlists.data;
		},

		/* Set the playlist */
		setPlaylist(state, playlist) {
			state.playlist = playlist.data;
		},

		/* Sets the playlist to be edited */
		setPlaylistEdit(state, playlist) {
			state.playlistEdit = playlist;
		},

		/* Sets the playlist edit text */
		setPlaylistEditText(state, text) {
			state.playlistEditText = text;
		},

		clearSingle(state) {
			state.playlist = {
				title: '',
				description: '',
				projects: [],
				password: '',
				hash_id: ''
			};
			console.log('store.playlist cleared!');
		},

		/* Set the playlists load status */
		setPlaylistsLoadStatus(state, status) {
			state.playlistsLoadStatus = status;
		},

		/* Set the playlist load status */
		setPlaylistLoadStatus(state, status) {
			state.playlistLoadStatus = status;
		},

		/* Sets the playlist edit status */
		setPlaylistEditStatus(state, status) {
			state.playlistEditStatus = status;
		},

		/* Sets the playlist delete status */
		setPlaylistDeleteStatus(state, status) {
			state.playlistDeleteStatus = status;
		},

		/* Sets the playlist edit load status */
		setPlaylistEditLoadStatus(state, status) {
			state.playlistEditLoadStatus = status;
		},

		/* Sets the playlist's industries */
		setPlaylistAddStatus(state, status) {
			state.playlistAddStatus = status;
		}
	},

	/* Defines the getters used by the module */
	getters: {
		/* Returns the playlists load status. */
		getPlaylistsLoadStatus(state) {
			return state.playlistsLoadStatus;
		},

		/* Returns the playlists delete status. */
		getPlaylistsDeleteStatus(state) {
			return state.playlistsDeleteStatus;
		},

		/* Returns the playlists. */
		getPlaylists(state) {
			return state.playlists;
		},

		/* Returns the playlists load status */
		getPlaylistLoadStatus(state) {
			return state.playlistLoadStatus;
		},

		/* Returns the playlist */
		getPlaylist(state) {
			return state.playlist;
		},

		/* Gets the playlist we are editing */
		getPlaylistEdit(state) {
			return state.playlistEdit;
		},

		/* Gets the playlist edit status */
		getPlaylistEditStatus(state) {
			return state.playlistEditStatus;
		},

		/* Gets the playlist edit text */
		getPlaylistEditText(state) {
			return state.playlistEditText;
		},

		/* Gets the playlist edit load status */
		getPlaylistEditLoadStatus(state) {
			return state.playlistEditLoadStatus;
		},

		/* Gets the playlist add status */
		getPlaylistAddStatus(state) {
			return state.playlistAddStatus;
		}
		// ,
		// getProjectsArray(state) {
		// 	var array = state.playlist.projects.map(opt => opt.id);
		// 	return array;
		// }
	}
};
